/** Companies that cannot use Explorador Excel export (toolbar "Exportar"). */
export const EXPLORER_CSV_DISABLED_COMPANY_IDS = [
  "69d6968b43421978328c1ad1",
  "6a67b1cd9ce78744bbdbdd91",
];

/**
 * Whether Explorador Excel export is allowed.
 * Company denylist blocks everyone. Per-user: missing/undefined = on (legacy users);
 * new users are created with `false` until an admin enables them.
 */
export function canExportExplorerCsv(
  companyId?: string | null,
  explorerCsvExportEnabled?: boolean | null,
): boolean {
  if (companyId != null && EXPLORER_CSV_DISABLED_COMPANY_IDS.includes(companyId)) {
    return false;
  }
  return explorerCsvExportEnabled !== false;
}
